export const framed = true
export const partner = 'fantasyfootballers'
export const overridePerms = true
export const authed = false
export const customPresets = true

// CSS Overrides
export const overridePrimary = '#42ab4e'
export const overrideSecondary = '#999'
export const overrideCheckboxColor = '#ad7a5e'
// TEMP remove
export const api_token = 'wuOOYr1ZInN5aG6LaoRtx4eFdZCsNAH6'
export const api_id = '207859'

export const allowCheatsheets = false